import { render, staticRenderFns } from "./WeightSelectionDialog.vue?vue&type=template&id=622c7166&"
import script from "./WeightSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./WeightSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports